import { originalLangType } from "@customer-tools-web/component-i18n";
export type UserType = {
  id: string;
  email: string | null;
  fullName: { [key in originalLangType]: string | null } | null;
  organisationId: number | null;
} & { [P in string]: any };

export const parseUser = (user: UserType, locale: string) => {
  const originLocale = locale.replace("-", "_") as originalLangType;
  const name = (user.fullName && user.fullName[originLocale]) || "";
  const enName = (user.fullName && user.fullName.en_GB) || "";
  return {
    id: user.id,
    email: user.email,
    name: name,
    en_name: enName,
    orgId: user.organisationId,
  };
};

export type ParsedUser = {
  id: string;
  email: string | null;
  name: string;
  en_name: string;
  orgId: number | null;
};
